export * from "./ar.js";
export * from "./de.js";
export * from "./en.js";
export * from "./es.js";
export * from "./fa.js";
export * from "./fr.js";
export * from "./he.js";
export * from "./hr.js";
export * from "./is.js";
export * from "./it.js";
export * from "./ja.js";
export * from "./ko.js";
export * from "./nl.js";
export * from "./no.js";
export * from "./pl.js";
export * from "./pt.js";
export * from "./ru.js";
export * from "./sk.js";
export * from "./uk.js";
export * from "./vi.js";
export * from "./zh.js";
export * from "./zh-tw.js";
export * from "./uz.js";
